import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Popconfirm, Tooltip , theme  } from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  PlusCircleFilled,
} from "@ant-design/icons";
import {
  ExclamationCircleFilled,
  CloseCircleFilled,
  CheckCircleFilled,
} from "@ant-design/icons";
import TSTable from "../../common/TSTable";
import ColorButton from "../../common/ColorButton";
import { DELETE } from "../../frameworks/HttpClient";
import { URL_TRUCK } from "../../constants/urls";
import ConditionsOfPurchaseModal from "./ConditionsOfPurchaseModal";
import ErrorMessages from "../../common/ErrorMessages";
import CustomDeleteConfirmButton from "../../common/CustomDeleteConfirmButton";

const ConditionsOfPurchaseList = (props) => {
  const [openAddConditionsOfPurchaseModal, setOpenAddConditionsOfPurchaseModal] = useState(false);
  const [target, setTarget] = useState(null);
  const [data, setData] = useState([]);
  const tableRef = useRef(null);
  const [errorMessage , setErrorMessage] = useState (null);
  const {
    token: { colorWarning, colorError, colorSuccess },
  } = theme.useToken();

  //set รอ ฟิก code 
  const fetchData = async () => {
    const response = await fetch(URL_TRUCK.CONDITIONS_OF_PURCHASE);
    const data = await response.json();
    setData(data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleDelete = async (id) => {
    if (!id) return;
    setErrorMessage(null);
    try {
      await DELETE(`${URL_TRUCK.CONDITIONS_OF_PURCHASE}${id}/`);
      refreshData();
    } catch (error) {
      setErrorMessage(error.errorMessage);
    }
  };

  const handleEdit = (record) => {
    if (!record || !record.id) { 
      return;
    } 
    setTarget(record);
    setOpenAddConditionsOfPurchaseModal(true);
  }
  

  const refreshData = async () => {
    if (tableRef.current) {
      setErrorMessage(null);
      try {
        await tableRef.current.fetchWithoutResetPage();
      } catch (error) {
        setErrorMessage(error.errorMessage);
      }

    }
  };

  const getIconForType = (type) => {
    switch (type) {
      case "danger":
        return <CloseCircleFilled style={{ color: colorError }} />;
      case "warning":
        return <ExclamationCircleFilled style={{ color: colorWarning }} />;
      case "success":
        return <CheckCircleFilled style={{ color: colorSuccess}} />;
      default:
        return null;
    }
  };

  const columns = [
    {
      title: "Action",
      dataIndex: "",
      width: 200,
      key: "action",
      align: "center",
      render: (_, record) =>
        (
          <div onClick={(e) => e.stopPropagation()}>
            <Popconfirm
              title="ยืนยันการลบรายการนี้หรือไม่?"
              onConfirm={() => handleDelete(record.id)}
              okText="ยืนยัน"
              cancelText="ยกเลิก"
              placement="top"
              okButtonProps= {{ 
                style: { backgroundColor : colorError} 
              }}
            >
              <Tooltip triger='hover' title="ลบรายการ">
              < CustomDeleteConfirmButton
                  title={`ยืนยันลบหรือไม่`}
                  content={"ยืนยันการลบรายการนี้หรือไม่ ?"}
                  onOk={ async() => {
                    await handleDelete(record.id)
                    refreshData();
                  }}
                  onConfirm={() => refreshData()}
                />
              </Tooltip>
            </Popconfirm>
            <Tooltip triger='hover' title="แก้ไขข้อมูล">
              <ColorButton
                type="primary"
                override={colorWarning}
                style={{ margin : 5}}
                icon={<EditOutlined />}
                onClick={() => handleEdit(record)}
              />
            </Tooltip>
          </div>
        ),
    },
    {
      title: "สารเคมี",
      dataIndex: "chemical",
      key: "chemical",
      ellipsis: true,
      align: "center",
      searcher: true,
    },
    {
      title: "เริ่มต้น",
      dataIndex: "min_value",
      key: "min_value",
      align: "center",
    },
    {
      title: "สิ้นสุด",
      dataIndex: "max_value",
      key: "max_value",
      align: "center",
    },
    {
      title: "ผลการรับซื้อ",
      dataIndex: "type",
      key: "type",
      align: "center",
      render: (text) => <span>{getIconForType(text)}</span>,
    },
    {
      title: "ตัดราคา (บาท/กิโลกรัม)",
      dataIndex: "cut_price",
      key: "cut_price",
      align: "center",
    },
    {
      title: "รายละเอียด",
      dataIndex: "note",
      key: "note",
      align: "center",
    },
  ];

  return (
    <div>
      <ErrorMessages messaage={errorMessage}/>
      <Row justify="space-between" style={{ marginBottom: 10 }}>
        <Col span={6}>
          {/* <Select
            placeholder="เลือกสารเคมี"
            onChange={handleChemicalChange}
            style={{ width: "100%" }}
            allowClear
          >
            {uniqueChemicals.map((chemical) => (
              <Select.Option key={chemical.chemical} value={chemical.chemical}>
                {chemical.chemical}
              </Select.Option>
            ))}
          </Select> */}
        </Col>
        <Col>
          <ColorButton
            type="primary"
            override={colorSuccess}
            style={{ marginBottom: 5 }}
            onClick={() => setOpenAddConditionsOfPurchaseModal(true)}
          >
            + เพิ่มเงื่อนไข
          </ColorButton>
        </Col>
      </Row>

      <TSTable
        columns={columns}
        dataSource={data}
        size="small"
        ref={tableRef}
        url={URL_TRUCK.CONDITIONS_OF_PURCHASE} 
      />

      <ConditionsOfPurchaseModal
        open={openAddConditionsOfPurchaseModal}
        onClose={() => {
          setOpenAddConditionsOfPurchaseModal(false);
          setTarget(null);
          refreshData();
        }}
        onUpdate={refreshData}
        target={target}
      />
    </div>
  );
};

//รอแก้ฟิวเตอร์ 

export default ConditionsOfPurchaseList;